// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"42a8dd1d835cacd0cd2e","678":"0bf5348738331b273028","883":"4f11664cb3a99a1669ac"}[chunkId] + ".js";
};